import { Component, EventEmitter, OnInit, OnDestroy, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../../services/wizard-state.service';
import { WizardEngineService } from '../../../../services/wizard-engine.service';
import { CurrentUserService } from '../../../../../../services/current-user.service';
import { AiPortraitTokenService } from '../../../../../../pages/player/modals/ai-generation/service/ai-portrait-token.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-manual-confirm-step',
    templateUrl: './manual-confirm-modal.component.html',
    styleUrls: ['./manual-confirm-modal.component.scss'],
    standalone: false
})
export class ManualConfirmStepComponent implements OnInit, OnDestroy {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  mapName = 'your world';
  worldCredits = 0;
  isLoading = false;
  private userId: any = null;
  private userSub: Subscription | null = null;

  constructor(private stateService: WizardStateService,
    private engineService: WizardEngineService,
    private currentUserService: CurrentUserService,
    private tokenService: AiPortraitTokenService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.mapName = this.stateService.currentState.mapName || 'your world';

    this.userSub = this.currentUserService.currentUser.subscribe(user => {
      if (user) {
        this.userId = user.id || user.user_id;
        this.fetchCreditBalance();
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }

  fetchCreditBalance(): void {
    if (!this.userId) return;
    this.isLoading = true;
    this.tokenService.getTokenBalance(this.userId).subscribe({
      next: (res: any) => {
        if (res && res.breakdown) {
          this.worldCredits = res.breakdown.world_credits || 0;
        }
        this.isLoading = false;
      
          this.cdr.detectChanges();},
      error: (err) => {
        console.error('Error fetching credit balance:', err);
        this.isLoading = false;
      
          this.cdr.detectChanges();}
    });
  }

  onProceed(): void {
    this.next.emit();
  }

  onBack(): void {
    this.back.emit();
  }

  onClose(): void {
    this.back.emit();
  }
}
